import React, {FC, useEffect, useState} from "react"

import {CompanyNewsTileConfig} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, Label, H6} from "@irati/ui/src/Typography"
import Icon from "@irati/ui/src/Icon"
import {PickFromLibraryIconWrapper, PickFromLibraryStyledCardContainer, StyledSvgCard} from "../Template/styled"
import {useCultureHubStore} from "../../../stores/hooks"

interface Props {
  companyNewsTileConfig: CompanyNewsTileConfig
  updateContent: (companyNewsTileConfig: CompanyNewsTileConfig) => void
}

interface CompanyNewsTileTemplate {
  backgroundColor: string
  templateIcon: string
  templateText: string
}

const PickFromLibrary: FC<Props> = ({companyNewsTileConfig, updateContent}) => {
  const {dispatch} = useCultureHubStore()
  const [selectedTemplate, setSelectedTemplate] = useState<CompanyNewsTileTemplate>()
  const [stagedTemplateBackgroundColor, setStagedTemplateBackgroundColor] = useState<string | undefined>(undefined)

  useEffect(() => {
    setStagedTemplateBackgroundColor(companyNewsTileConfig?.backgroundColor)
  }, [companyNewsTileConfig])

  const handleClick = () => {
    updateContent(Object.assign({}, companyNewsTileConfig, {...selectedTemplate, imageUrl: ""}))
    dispatch({
      type: "SET_MODAL_STATE",
      payload: {modalState: undefined}
    })
  }

  return (
    <Flex direction="column" gap={1.5}>
      <Body>
        <FormattedMessage id="culturehub.companyNews.modal.pickFromLibrary.screen.title" />
      </Body>
      <Flex wrap="wrap" gap={1}>
        {templateLibrary.map((template: CompanyNewsTileTemplate) => (
          <Flex key={template.backgroundColor} id={`id-${template.templateIcon}`} width="120px" flex="1">
            <StyledSvgCard
              color={template.backgroundColor}
              isSelected={template.backgroundColor === (selectedTemplate?.backgroundColor || stagedTemplateBackgroundColor)}
              onClick={() => setSelectedTemplate(template)}>
              <PickFromLibraryStyledCardContainer>
                <PickFromLibraryIconWrapper>
                  <Icon icon={template.templateIcon} size={16} />
                </PickFromLibraryIconWrapper>
                {template?.templateText && (
                  <H6 color="white" textAlign="center">
                    <FormattedMessage id={template.templateText} />
                  </H6>
                )}
                <Label color="white" textAlign="center">
                  <FormattedMessage id="platform.homepage.companyNews.template.findOutMore" />
                </Label>
              </PickFromLibraryStyledCardContainer>
            </StyledSvgCard>
          </Flex>
        ))}
      </Flex>
      <Flex justifyContent="flex-end">
        <Button primary onClick={handleClick}>
          <FormattedMessage id="platform.successStep.success.title" />
        </Button>
      </Flex>
    </Flex>
  )
}

export const templateLibrary: CompanyNewsTileTemplate[] = [
  {
    backgroundColor: "#EE6352",
    templateIcon: "calendar",
    templateText: "platform.homepage.companyNews.template.companyCalendar"
  },
  {
    backgroundColor: "#7856E7",
    templateIcon: "announcement",
    templateText: "platform.homepage.companyNews.template.announcement"
  },
  {
    backgroundColor: "#EAC900",
    templateIcon: "event",
    templateText: "platform.homepage.companyNews.template.companyEvent"
  },
  {
    backgroundColor: "#21A0A0",
    templateIcon: "values",
    templateText: "platform.homepage.companyNews.template.companyValues"
  },
  {
    backgroundColor: "#F1BB6C",
    templateIcon: "party",
    templateText: "platform.homepage.companyNews.template.party"
  },
  {
    backgroundColor: "#FF5555",
    templateIcon: "people",
    templateText: "platform.homepage.companyNews.template.employeeReferral"
  },
  {
    backgroundColor: "#95CDC7",
    templateIcon: "play-video",
    templateText: "platform.homepage.companyNews.template.perkbox"
  },
  {
    backgroundColor: "#B4BAC6",
    templateIcon: "reminder",
    templateText: "platform.homepage.companyNews.template.reminder"
  },
  {
    backgroundColor: "#0DB690",
    templateIcon: "clipboard",
    templateText: "platform.homepage.companyNews.template.volunteer"
  },
  {
    backgroundColor: "#00ADEE",
    templateIcon: "blog",
    templateText: "platform.homepage.companyNews.template.companyBlog"
  },
  {
    backgroundColor: "#4A90E2",
    templateIcon: "clock",
    templateText: "platform.homepage.companyNews.template.extraShifts"
  },
  {
    backgroundColor: "#4A7BB4",
    templateIcon: "newsletter",
    templateText: "platform.homepage.companyNews.template.newsletter"
  }
]

export default PickFromLibrary
